export default function Lights()
{

    return <>
        <directionalLight
            castShadow
            position={ [ 17, 20, -17 ] }
            intensity={ 0.9 }
            shadow-mapSize={ [ 2048, 2048 ] }
            shadow-camera-near={ 1 }
            shadow-camera-far={ 50 }
            shadow-normalBias = {0}
            shadow-radius = {10}
            shadow-camera-top={ 60 }
            shadow-camera-right={ 40 }
            shadow-camera-bottom={ - 40 }
            shadow-camera-left={ - 60 }
        />
        <ambientLight intensity={ 0.5 } />

    </>
}